(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mdl_axeptio_cookie_settings"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__mdlAxeptioCookieSettingsInit) return;
    window.__mdlAxeptioCookieSettingsInit = true;

    let axeptioSdk;
    window._axcb = window._axcb || [];
    window._axcb.push((sdk) => {
      axeptioSdk = sdk;
    });

    const openCookieSettings = () => {
      if (typeof window.openAxeptioCookies === 'function') {
        window.openAxeptioCookies();
        return true;
      }

      if (axeptioSdk && typeof axeptioSdk.openCookies === 'function') {
        axeptioSdk.openCookies();
        return true;
      }

      if (window.axeptioSDK && typeof window.axeptioSDK.openCookies === 'function') {
        window.axeptioSDK.openCookies();
        return true;
      }

      return false;
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-mdl-axeptio-cookie-settings]');
      if (!trigger || !openCookieSettings()) return;
      event.preventDefault();
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
